import { Link } from 'react-router';
import { LoginHero } from './LoginHero';

export function LandingPage() {
  return (
    <div className="login-landing">
      <LoginHero />

      <aside className="login-form-col">
        <div className="login-auth-card">
          <div className="login-auth-head">
            <p className="login-auth-head-kicker">Get started</p>
            <h2>Sign in to your school workspace.</h2>
            <p>
              Access attendance, fees, marks, and communication — all in one place.
            </p>
          </div>

          <Link to="/login" className="btn btn-primary btn-lg btn-block">
            Sign in to your account
          </Link>

          <hr className="public-divider" />

          <div className="public-footnote">
            <Link to="/demo">Try demo mode</Link>
          </div>

          <div className="public-footnote mt-2">
            Don't have an account?{' '}
            <Link to="/signup">Start free trial</Link>
            <span className="footnote-sep">·</span>
            <Link to="/pricing">View pricing</Link>
          </div>
        </div>
      </aside>
    </div>
  );
}